import React from 'react'

const EditDimensionDetails = ({settings, handleDimensionDetailsChanges}) => {

    return (
        <>

            <div className="ml-2 field-label">
                Dimension (Width x Height)
            </div>

            <div className="flex justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <input type="number" placeholder="Width"
                               id="width"
                               name="width"
                               value={settings?.width}
                               onChange={handleDimensionDetailsChanges}
                               className="input-field number-input-field"/>
                    </div>
                    <div className="field-container">
                        <input type="number" placeholder="Height"
                               id="height"
                               name="height"
                               value={settings?.height}
                               onChange={handleDimensionDetailsChanges}
                               className="input-field number-input-field"/>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EditDimensionDetails
